import type { ReactNode } from 'react'
import { Label } from '@/components/ui/label'
import { cn } from '@/lib/utils'

/** Başlıklı form bölümü: içerik 2 sütunlu ızgara (mobilde tek sütun). */
export function FormSection({ title, children, className }: { title?: ReactNode; children: ReactNode; className?: string }) {
  return (
    <fieldset className={cn('min-w-0 space-y-3', className)}>
      {title ? <legend className="mb-3 w-full border-b pb-1.5 text-xs font-semibold uppercase tracking-wide text-muted-foreground">{title}</legend> : null}
      <div className="grid grid-cols-1 gap-x-4 gap-y-4 sm:grid-cols-2">{children}</div>
    </fieldset>
  )
}

type FieldProps = { id: string; label: ReactNode; error?: string; hint?: ReactNode; full?: boolean; className?: string; children: ReactNode }

/** Etiket + kontrol + (ipucu | hata). `full` tam satır kaplar. */
export function Field({ id, label, error, hint, full, className, children }: FieldProps) {
  return (
    <div className={cn('flex min-w-0 flex-col gap-1.5', full && 'sm:col-span-2', className)}>
      <Label htmlFor={id}>{label}</Label>
      {children}
      {error ? <p className="text-xs text-destructive">{error}</p> : hint ? <p className="text-xs text-muted-foreground">{hint}</p> : null}
    </div>
  )
}

/** Düzenlenemeyen değeri giriş alanıyla aynı yükseklikte gösterir (hizalama için). */
export function ReadonlyValue({ id, children }: { id: string; children: ReactNode }) {
  return (
    <div id={id} className="flex h-9 items-center rounded-md border border-dashed bg-muted/40 px-3 text-sm font-semibold tabular-nums">
      {children}
    </div>
  )
}

/** Tam satır onay kutusu; açıklamasıyla birlikte. */
export function CheckRow({ children, hint, ...input }: React.ComponentProps<'input'> & { hint?: ReactNode }) {
  return (
    <label className="flex items-start gap-2.5 rounded-lg border bg-muted/20 p-3 text-sm sm:col-span-2">
      <input type="checkbox" className="mt-0.5 size-4 shrink-0 accent-[var(--color-primary)]" {...input} />
      <span>
        {children}
        {hint ? <span className="block text-xs text-muted-foreground">{hint}</span> : null}
      </span>
    </label>
  )
}
